













import { Prop, Component, Vue } from 'vue-property-decorator'
import { ReferralsStateFilters } from '@/store/referrals'
import { namespace } from 'vuex-class'
const referrals = namespace('referrals')

interface SearchAlternative {
    title: string
    count: number
    filters: ReferralsStateFilters
}

@Component
export default class AlternativeBlock extends Vue {
    @Prop() readonly title!: string
    @Prop() readonly text!: string
    @Prop() readonly items!: SearchAlternative[]
    @referrals.State readonly search!: string|null
    @referrals.Action applyFilters: (ReferralsStateFilters) => Promise<void>

    async doApplyFilters(filters: ReferralsStateFilters): Promise<void> {
        await this.applyFilters({
            ...filters,
            search: this.search,
        })
    }
}
